import React, { useEffect, useState } from "react";
import api from "../../services/api";

const couleurScore = (score) => {
  if (score >= 80) return { bg: "#f0fdf4", text: "#16a34a", label: "Très fiable" };
  if (score >= 60) return { bg: "#fefce8", text: "#ca8a04", label: "Fiable" };
  if (score >= 40) return { bg: "#fff7ed", text: "#ea580c", label: "À risque" };
  return { bg: "#fef2f2", text: "#dc2626", label: "Bloqué" };
};

const statutBadge = (statut) => {
  const map = {
    "Fiable":      { bg: "#fefce8", text: "#ca8a04" },
    "Tres fiable": { bg: "#f0fdf4", text: "#16a34a" },
    "A risque":    { bg: "#fff7ed", text: "#ea580c" },
    "Bloque":      { bg: "#fef2f2", text: "#dc2626" },
    "Archive":     { bg: "#f3f4f6", text: "#6b7280" },
  };
  return map[statut] || { bg: "#f3f4f6", text: "#6b7280" };
};

const ModalArchivage = ({ client, action, onClose, onSuccess }) => {
  const [commentaire, setCommentaire] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.put(`/clients/${client.id}/${action === "archiver" ? "archiver" : "reactiver"}`, { commentaire });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0, color: action === "archiver" ? "#dc2626" : "#16a34a" }}>
            {action === "archiver" ? "Archiver" : "Réactiver"} {client.prenom} {client.nom}
          </h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>
            Commentaire {action === "archiver" ? "(raison d'archivage)" : "(raison de réactivation)"}
          </label>
          <textarea value={commentaire} onChange={(e) => setCommentaire(e.target.value)}
            placeholder="Ex: Client décédé, déménagement..." rows={3}
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white", resize: "none", marginBottom: "1.25rem" }} />
          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "0.75rem",
            background: action === "archiver" ? "#dc2626" : "linear-gradient(135deg, #7c3aed, #9333ea)",
            color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none",
            cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1
          }}>
            {loading ? "Traitement..." : action === "archiver" ? "Archiver" : "Réactiver"}
          </button>
        </form>
      </div>
    </div>
  );
};

const BadgeCredit = ({ client }) => {
  if (client.credit_non_rembourse) {
    return (
      <span style={{ fontSize: "11px", backgroundColor: "#fef2f2", color: "#dc2626", padding: "2px 8px", borderRadius: "6px", flexShrink: 0, fontWeight: "500" }}>
        Non remboursé — {Number(client.credit_non_rembourse.montant).toLocaleString("fr-FR")} F
      </span>
    );
  }
  if (client.credit_en_cours) {
    const enRetard = new Date(client.credit_en_cours.echeance) < new Date();
    return (
      <span style={{ fontSize: "11px", backgroundColor: enRetard ? "#fff7ed" : "#E6F1FB", color: enRetard ? "#ea580c" : "#185FA5", padding: "2px 8px", borderRadius: "6px", flexShrink: 0, fontWeight: "500" }}>
        {enRetard ? "En retard" : "Crédit en cours"} — {Number(client.credit_en_cours.montant).toLocaleString("fr-FR")} F
      </span>
    );
  }
  return (
    <span style={{ fontSize: "11px", backgroundColor: "#f0fdf4", color: "#16a34a", padding: "2px 8px", borderRadius: "6px", flexShrink: 0 }}>
      Disponible
    </span>
  );
};

const ClientsAdmin = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filtreStatut, setFiltreStatut] = useState("tous");
  const [filtreCredit, setFiltreCredit] = useState("tous");
  const [modal, setModal] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchClients = async () => {
    try {
      const res = await api.get("/clients");
      setClients(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchClients(); }, []);

  const handleSuccess = () => {
    setModal(null);
    setSuccessMsg("Action effectuée avec succès !");
    fetchClients();
    setTimeout(() => setSuccessMsg(""), 3000);
  };

  const clientsFiltres = clients.filter((c) => {
    const matchSearch = `${c.nom} ${c.prenom} ${c.commercial_nom || ""} ${c.commercial_prenom || ""}`.toLowerCase().includes(search.toLowerCase());
    const matchStatut = filtreStatut === "tous" || c.statut === filtreStatut;
    const matchCredit = filtreCredit === "tous"
      || (filtreCredit === "en_cours" && c.credit_en_cours)
      || (filtreCredit === "non_rembourse" && c.credit_non_rembourse)
      || (filtreCredit === "disponible" && !c.credit_en_cours && !c.credit_non_rembourse);
    return matchSearch && matchStatut && matchCredit;
  });

  const nbEnCours = clients.filter(c => c.credit_en_cours).length;
  const nbNonRembourse = clients.filter(c => c.credit_non_rembourse).length;
  const nbDisponible = clients.filter(c => !c.credit_en_cours && !c.credit_non_rembourse && c.statut !== "Archive").length;

  return (
    <>
      {modal && (
        <ModalArchivage client={modal.client} action={modal.action}
          onClose={() => setModal(null)} onSuccess={handleSuccess} />
      )}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Clients</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>{clients.filter(c => c.statut !== "Archive").length} client(s) actifs</p>
        </div>
      </div>

      {/* Stats rapides */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "10px", marginBottom: "1.25rem" }}>
        {[
          { label: "Crédits en cours", value: nbEnCours, color: "#185FA5", bg: "#E6F1FB" },
          { label: "Non remboursés", value: nbNonRembourse, color: "#dc2626", bg: "#fef2f2" },
          { label: "Disponibles", value: nbDisponible, color: "#0f6e56", bg: "#E1F5EE" },
        ].map((s, i) => (
          <div key={i} style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "0.75rem 1rem" }}>
            <div style={{ fontSize: "11px", color: "#6b7280", marginBottom: "4px" }}>{s.label}</div>
            <div style={{ fontSize: "20px", fontWeight: "500", color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {successMsg && (
        <div style={{ marginBottom: "1rem", padding: "0.75rem 1rem", backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", color: "#16a34a", fontSize: "13px" }}>
          {successMsg}
        </div>
      )}

      {/* Recherche */}
      <div style={{ position: "relative", marginBottom: "1rem" }}>
        <svg width="14" height="14" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24"
          style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }}>
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" placeholder="Rechercher par nom, prénom ou commercial..."
          value={search} onChange={(e) => setSearch(e.target.value)}
          style={{ width: "100%", padding: "0.65rem 0.9rem 0.65rem 2.25rem", border: "1px solid #e5e7eb", borderRadius: "9999px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white" }} />
      </div>

      {/* Filtre statut */}
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "0.75rem" }}>
        {[
          { value: "tous", label: "Tous" },
          { value: "Fiable", label: "Fiables" },
          { value: "Tres fiable", label: "Très fiables" },
          { value: "A risque", label: "À risque" },
          { value: "Bloque", label: "Bloqués" },
          { value: "Archive", label: "Archivés" },
        ].map((f) => (
          <button key={f.value} onClick={() => setFiltreStatut(f.value)} style={{
            padding: "0.4rem 0.9rem", borderRadius: "9999px", fontSize: "12px",
            border: filtreStatut === f.value ? "none" : "1px solid #e5e7eb",
            backgroundColor: filtreStatut === f.value ? "#7c3aed" : "white",
            color: filtreStatut === f.value ? "white" : "#6b7280", cursor: "pointer"
          }}>{f.label}</button>
        ))}
      </div>

      {/* Filtre crédit */}
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1.25rem" }}>
        {[
          { value: "tous", label: "Tous crédits" },
          { value: "en_cours", label: "Crédit en cours" },
          { value: "non_rembourse", label: "Non remboursé" },
          { value: "disponible", label: "Disponible" },
        ].map((f) => (
          <button key={f.value} onClick={() => setFiltreCredit(f.value)} style={{
            padding: "0.4rem 0.9rem", borderRadius: "9999px", fontSize: "12px",
            border: filtreCredit === f.value ? "none" : "1px solid #e5e7eb",
            backgroundColor: filtreCredit === f.value ? "#185FA5" : "white",
            color: filtreCredit === f.value ? "white" : "#6b7280", cursor: "pointer"
          }}>{f.label}</button>
        ))}
      </div>

      {/* Liste */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Chargement...</div>
        ) : clientsFiltres.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>👤</div>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucun client trouvé</p>
          </div>
        ) : (
          clientsFiltres.map((client, i) => {
            const sc = couleurScore(client.score || 60);
            const sb = statutBadge(client.statut);
            return (
              <div key={client.id} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "0.9rem 1.25rem", borderBottom: i < clientsFiltres.length - 1 ? "0.5px solid #f3f4f6" : "none", flexWrap: "wrap" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: sc.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "500", color: sc.text, flexShrink: 0 }}>
                  {client.nom?.charAt(0)}{client.prenom?.charAt(0)}
                </div>
                <div style={{ flex: 1, minWidth: "150px" }}>
                  <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>{client.prenom} {client.nom}</div>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                    {client.telephone || "—"} · {client.activite || "—"}
                  </div>
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "2px" }}>
                    Commercial : {client.commercial_prenom} {client.commercial_nom}
                  </div>
                </div>
                <div style={{ textAlign: "center", flexShrink: 0 }}>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: sc.text }}>{client.score || 60}</div>
                  <div style={{ fontSize: "10px", color: "#9ca3af" }}>score</div>
                </div>
                <span style={{ fontSize: "11px", padding: "3px 10px", borderRadius: "6px", backgroundColor: sb.bg, color: sb.text, flexShrink: 0 }}>
                  {client.statut}
                </span>
                <BadgeCredit client={client} />
                {client.statut === "Archive" ? (
                  <button onClick={() => setModal({ client, action: "reactiver" })} style={{ padding: "0.4rem 0.9rem", backgroundColor: "#f3e8ff", color: "#7c3aed", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer", flexShrink: 0 }}>
                    Réactiver
                  </button>
                ) : (
                  <button onClick={() => setModal({ client, action: "archiver" })} style={{ padding: "0.4rem 0.9rem", backgroundColor: "#fef2f2", color: "#dc2626", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer", flexShrink: 0 }}>
                    Archiver
                  </button>
                )}
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default ClientsAdmin;